import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jarvis-layout',
  templateUrl: './jarvis-layout.component.html',
  styles: [
  ]
})
export class JarvisLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
